import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const uploadPdfShotClass = (
  classId,
  fileExtension,
  isVariant,
  status,
  data
) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_PDF_SHOTCLASS(
      classId,
      fileExtension,
      isVariant,
      status
    ),
    data
  );
};

export default uploadPdfShotClass;
